"use client"
/* */
import { useSlotContext } from './slotContext.mjs';

const useContextSlot = (component) => useSlotContext()[component];

export { useContextSlot as default, useContextSlot };
//# sourceMappingURL=useContextSlot.mjs.map
